import * as React from 'react'

import { styled } from '~/styled'

const StyledTableBody = styled('tbody', {
  base: [],
  variants: {
    striped: {
      true: ['[&_tr]:even:bg-grey-100', '[&_tr]:odd:bg-white'],
      false: ['[&_tr]:bg-white']
    }
  }
})

type TableBodyProps = React.ComponentProps<typeof StyledTableBody>

export const TableBody = ({ striped = true, ...rest }: TableBodyProps) => (
  <StyledTableBody striped={striped} {...rest} />
)

TableBody.displayName = 'TableBody'
